import {
  effect,
  EnvironmentProviders,
  ErrorHandler,
  inject,
  Injector,
  Provider,
  provideAppInitializer,
  runInInjectionContext,
} from '@angular/core';

import { ChunkErrorHandler } from './chunk-error.handler';
import { DEFAULT_VERSION_CHECK_CONFIG, VERSION_CHECK_CONFIG, VersionCheckConfig } from './version-check.model';
import { VersionCheckService } from './version-check.service';

export function provideVersionCheck(
  notificationCallback?: (service: VersionCheckService) => void,
  config?: Partial<VersionCheckConfig>,
): (Provider | EnvironmentProviders)[] {
  const providers: (Provider | EnvironmentProviders)[] = [
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
    provideAppInitializer(() => {
      const service = inject(VersionCheckService);
      const injector = inject(Injector);
      service.init();

      if (notificationCallback) {
        effect(() => {
          if (service.showIdleBanner()) {
            // An effect body is not an injection context: a callback that injects its notifier
            // (every caller does) throws NG0203 and the update offer never reaches the screen.
            runInInjectionContext(injector, () => notificationCallback(service));
          }
        });
      }
    }),
  ];

  if (config) {
    providers.push({
      provide: VERSION_CHECK_CONFIG,
      useValue: { ...DEFAULT_VERSION_CHECK_CONFIG, ...config },
    });
  }

  return providers;
}
